export default {
    trial: {
        go_billing: 'GO TO BILLING',
        expired: 'Your trial period has expired!',
        ending: 'Your trial period is ending in less than <<24>> hours! | Your trial period is ending in <<1>> day! | Your trial period is ending in <<{numberOfDays}>> days!',
        demo_account: 'This is a demo account. Complete registration for full features.',
        finish_registration: 'START TODAY',
    },
    billing_address_modal: {
        edit: 'Edit billing address',
        address_label: 'Address',
        address_placeholder: 'address',
        city_label: 'City',
        city_placeholder: 'city',
        state_label: 'State',
        state_placeholder: 'state',
        zip_label: 'Zip',
        zip_placeholder: 'zip',
    },
    billing_list_modal: {
        credit_card: 'Credit Card:',
        active: 'Active',
        delete: 'Delete',
        delete_card: 'Are you sure you want to delete card',
    },
    premium: 'PREMIUM',
    network: 'NETWORK',
    features: 'FEATURES',
    enterprise: 'Premium',
    payment_method: 'Payment method',
    billing_form: {
        monthly: 'Monhtly billing',
        annual: 'Annual billing',
        year: '/year',
        month: '/month',
        billing_address: 'Billing address',
        street: 'Enter your street address',
        city: 'Enter your city',
        state: 'Enter your state',
        postcode: 'Enter your postcode',
    },
    table: {
        payment_history: 'Payment history',
        period: 'Period',
        fee: 'Fee',
        concierge: 'Concierge fees',
        total: 'Total',
        paid: 'Paid on',
        Invoice: 'Invoice',
        appointments: 'appointments',
        invoice: 'INVOICE',
        no_history: 'No payment history',
    },
    invoice_modal: {
        download: 'DOWNLOAD INVOICE',
        subscription: 'Subscription',
        period: 'Period',
        transcations: 'Transactions',
        amount: 'Amount',
        premium: 'Premium',
    },
}
